(function() { module.exports = this["NeoCommon"]; }());


/*****************
 ** WEBPACK FOOTER
 ** external "NeoCommon"
 ** module id = 2
 ** module chunks = 0
 **/